import type { BulkAction } from "@/components/shared/UniversalCRMTable/types";
import type { Deal } from "@/lib/types/database/deals";

export const dealActions = {
  view: true,
  edit: true,
  delete: true,
  manageHealth: true,
};

export const dealDetailActions = {
  edit: true,
  delete: true,
  manageHealth: true,
};

export const dealBulkActions: BulkAction<Deal>[] = [
  {
    id: "bulk_export_emails",
    label: "Export",
    icon: "Download",
  },
  {
    id: "bulk_update_status",
    label: "Update Status",
    icon: "check",
  },
  {
    id: "bulk_update_stage",
    label: "Update Stage",
    icon: "ArrowRight",
  },
  {
    id: "bulk_update_health",
    label: "Update Health Status",
    icon: "Activity",
  },
];
